import Resource from '@/api/resources/Resource'

class SubportionTypeServices extends Resource {
    async getSubportionTypes() {
        const response = await this.axios.get(`/subportionTypes/`)
        return response.data
    }
}

export default new SubportionTypeServices()
